/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, forwardRef, input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-input-radio',
  templateUrl: './input-radio.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRadioComponent),
      multi: true,
    },
  ],
})
export class InputRadioComponent implements ControlValueAccessor {
  label = input('');
  formControlName = input.required<string>();
  value = input.required<boolean>();
  disabled = input(false);

  private _selectedValue: boolean | undefined = undefined;
  private _isDisabledState = false;

  get radioId() {
    return `${this.formControlName}_${this.value}`;
  }

  get isChecked(): boolean {
    return this._selectedValue === this.value();
  }

  get isDisabled(): boolean {
    return this.disabled() || this._isDisabledState;
  }

  // ControlValueAccessor callback functions
  private onChange = (value: boolean) => {};
  private onTouched = () => {};

  onRadioChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      this._selectedValue = this.value();
      this.onChange(this._selectedValue);
    }
  }

  onBlur(): void {
    this.onTouched();
  }

  // ControlValueAccessor implementation
  writeValue(value: boolean): void {
    this._selectedValue = value || undefined;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._isDisabledState = isDisabled;
  }
}
